import { Routes, Route } from "react-router-dom";
import Layout from "../layout/index.js";
import Dashboard from '../pages/AlKauserAdminDashboard/index.jsx';
import EditProfile from '../components/EditProfile';
import UsersData from "../components/Table";

const adminRoutesData = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "applications", element: <UsersData />, text: "Applications" },
];

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout navItems={adminRoutesData} />}>
        {adminRoutesData.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;